var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{ref:"button",staticClass:"cz2__main-navigation-list-button",class:[
        _vm.headerFontClass,
        { cz2__alert: _vm.alert },
        { 'cz2__muted-more': _vm.disabled },
        { 'cz2__main-navigation-list-button--current': _vm.isCurrentGroup },
    ],attrs:{"aria-current":_vm.isCurrentGroup ? 'step' : false,"disabled":_vm.disabled}},[_c('div',{staticClass:"cz2__main-navigation-list-button-content-wrapper",class:[
            { cz2__alert: _vm.alert },
        ]},[_c('span',{staticClass:"cz2__main-navigation-list-button-content",domProps:{"innerHTML":_vm._s(_vm.groupName)}}),(_vm.alert)?_c('img',{staticClass:"cz2__main-navigation-list-button-alert",attrs:{"src":require("../assets/icons/alert.svg"),"alt":"Warning"}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }